// @flow
import Joi from "joi";
import type { JoiError, Errors } from "../types/campaign";
import type { BaseSimpleErrorsRule } from "./Base";

export default class Name implements BaseSimpleErrorsRule {
  schema: Object;

  errorKey: string;

  errors: Errors;

  constructor() {
    this.errors = {};
    this.errorKey = "name";

    this.schema = Joi
      .string()
      .pattern(/^[A-Za-z0-9\s_-]{1,64}$/)
      .error((errors) => this._onError(errors));
  }

  _onError(errors: Array<JoiError>): Array<JoiError> {
    errors.forEach((item) => {
      switch (item.code) {
        case "string.empty":
          this.errors = {
            ...this.errors,
            [this.errorKey]: { message: "Field required" },
          };
          break;
        case "string.pattern.base":
          this.errors = {
            ...this.errors,
            [this.errorKey]: { message: " Invalid name" },
          };
          break;
        default:
          this.errors = {
            ...this.errors,
            [this.errorKey]: { message: item.message },
          };
          break;
      }
    });

    return errors;
  }

  getErrors(data: *): Errors {
    this.schema.validate(data);
    return this.errors;
  }
}
